import { createReducer, on, Action } from '@ngrx/store';
import { EntityState, createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import * as UserActions from '../_actions/user';
import { User } from '../_models';

export interface UserState extends EntityState<User> {
  loading: boolean;
  error: any;
}

export const adapter: EntityAdapter<User> = createEntityAdapter<User>();

const initialState: UserState = adapter.getInitialState({
  loading: false,
  error: null,
});

const userReducer = createReducer(
  initialState,

  on(UserActions.loadUsers, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(UserActions.loadUsersSuccess, (state, { users }) =>
    adapter.setAll(users, { ...state, loading: false })
  ),

  on(UserActions.loadUsersFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(UserActions.addUserSuccess, (state, { user }) => adapter.addOne(user, state)),

  on(UserActions.updateUserSuccess, (state, { user }) => adapter.upsertOne(user, state)),

  on(UserActions.deleteUserSuccess, (state, { id }) => adapter.removeOne(id, state)),

  on(
    UserActions.addUserFailure,
    UserActions.updateUserFailure,
    UserActions.deleteUserFailure,
    (state, { error }) => ({
      ...state,
      error,
    })
  )
);

export function reducer(state: UserState | undefined, action: Action) {
  return userReducer(state, action);
}

export const { selectAll, selectEntities, selectTotal } = adapter.getSelectors();
